export default {
    SPECIFICATION: 'Specification',
    FRONT_VIEW: 'Front view',
    OUTSIDE_VIEW: 'Outside view',
    CLICK_TO_EDIT: 'Click item to edit',
    EDIT: 'EDIT',
    OK: 'OK',
    SELECTED_COLOR: 'SELECTED COLOR',
    NAME: 'Name',
    RENOLIT: 'Renolit',
    COLOR_PALETTE: 'Color palette',
    SEARCH: 'Search',
    ART_NR: 'Art-nr',
    RAL: 'RAL',
    PRICE: 'Price',
    ORNAMENT: 'Ornament',
    SELECT_GLASS_SUBHEADER: 'Select glass for each side of glass packet',
    SELECT_GLASS_SUBHEADER_INFO: 'Important information for you who will have full-glossy solutions! Glass under 60cm from walkable surface must be of personal safety glass. This means tempered or laminated glass. This rule applies both internally and externally.',
    MULLIONS_N_DIVIDERS: 'Mullions and dividers',
    DIVIDERS: 'Dividers',
    MULLIONS: 'Glazing bars',
    HORIZONTAL: 'Horizontal',
    VERTICAL: 'Vertical',
    SIZE: 'Size',
    INSIDE_COLOR: 'Inside Color',
    OUTSIDE_COLOR: 'Outside Color',
    GLAZING: 'Glazing',
    GLASS: 'Glass',
    HANDLES: 'Handles',
    ACTIVE_SASH_SIDE: 'Active sash side',
    FIXED_SASHES_OPTIONS: 'Fixed sashes options',
    HINGE_SIDE: 'Hinge side',
    SEAL_COLOR: 'Seal color',
    ACCESSORIES: 'Accessories',
    ACCESSORY: 'Accessory',
    UNITS: 'Units',
    UNITS_ROOF_WINDOW: 'Module/millimeter',
    BOTTOM_PANEL: 'Bottom Panel',
    QUANTITY: 'Quantity',
    PER_ITEM: 'Per item',
    VAT: 'VAT Included',
    ADD_TO_CART: 'ADD TO CART',
    SAVE_CHANGES: 'SAVE CHANGES',
    RESET_COLOR: 'Reset color',
    CHANGE_SERIES: 'Change series',
    WIDTH: 'Width',
    HEIGHT: 'Height',
    NONE_SELECTED: 'None selected',
    ORDINARY_PRICE: 'Ordinary price',
    PACKET: 'Packet',
    SAVING: 'You can save',
    INITIAL: 'Initial',
    WHY_PACKET: 'WHY SHOULD YOU SELECT THIS PACKAGE?',
    VALUE: 'Value',
    SAVE_MONEY: 'Select packet and save money',
    HINGE_TYPE: 'Hinge type',
    CHOOSE_BEST_SOLUTION: 'Choose the solution that suits you best',
    WINDOW_TILT_HINGE_SIDE: 'Hinge side',
    NO_PRICE: 'NO PRICE',
    DIMENSIONS_ERROR: 'The dimensions you want is not possible, please try with other dimensions or contact us for help at 0431-37 14 00',
    BLINDS_ERROR: 'Blinds pricelist is out of range',
    APRIS: 'Price per unit',
    CLASSIC: 'CLASSIC',
    DEFAULT_PACKET: 'CLASSIC',
    MULTI_PACKETS: 'MULTI PACKETS',
    MULLIONS_NOTE_WINDOWDOOR_RESTRICTION: 'When the width exceeds 1000mm, you must have a horizontal divider for the products strength. Contact us if you want a quote with spray solution.',
    MULLIONS_NOTE_PART_1: 'Note!',
    MULLIONS_NOTE_PART_2: 'If you have any questions about the location of your mullions please contact us',
    MULLIONS_NOTE_PART_3: 'here',
    MULLIONS_NOTE_PART_4: 'and we will help you',
    DIMENSION_INFO_HEADER: 'Dimensions info',
    DIMENSION_INFO_HEADER_MODAL: 'Dimensions info',
    DIMENSION_INFO: 'Below You find instructions about different shapes dimensions. Remember that You can set some dimensions to "0".',
    CASEMENT_INFO_BUTTON: 'I understand and want proceed',
    CASEMENT_INFO_HEADER_MODAL: 'Important!',
    CASEMENT_INFO: 'The product can only be manufactured with tilt function and without side hanging. The handle is placed at the top as shown below. If you want handles on the side you can easily change it under HANDLE in the configurator.',
    NEXT_STEP: 'Next',
    PREV_STEP: 'Previous',
    TOTAL_PRICE: 'Total price',
    RESET: 'Reset',
    MIRROR_REFLECTION: 'Open direction',
    INNER_VIEW: 'Inner view',
    OUTER_VIEW: 'Outer view',
    EMPTY: '',
    NOT_CHANGED: 'Not changed',
    COLORS: 'Colors',
    PREDEFINED_COLOR_MATCH: 'Predefined',
    CUSTOM_COLOR_MATCH: 'Custom',
    DOOR_STANDARD_COLOR: 'Standard colors',
    DOOR_HANDLES: 'Handle',
    HANDLE_COLOR: 'Handle color',
    HANDLE_OPTIONS: 'Handle options',
    DOOR_APPEARANCE: 'Colors',
    DELIVERY_PRICE_INFO: 'Frakt inom Sverige från',
    FREE_DELIVERY_INFO: 'Free delivery',
    DISCOUNT: 'Discount',
    YOU_SAVE: 'You save',
    BUILD_YOUR_OWN_WINDOW: 'Build Your own window',
    COLOR: 'Color',
    APPEARANCE: 'Appearance',
    CONFIGURATOR: 'Configurator',
    CONFIGURATOR_HELP_INFO: 'Select category and subcategory to change product',
    BTN_GO_TO_CONFIGURATOR_DEFAULT: 'Configure window - Click here!',
    BTN_GO_TO_CONFIGURATOR_WINDOW: 'Configure window - Click here!',
    BTN_GO_TO_CONFIGURATOR_WINDOW_DOOR: 'Configure window door - Click here!',
    BTN_GO_TO_CONFIGURATOR_FOLDING_DOOR: 'Configure folding door - Click here!',
    BTN_GO_TO_CONFIGURATOR_SLIDING_DOOR: 'Configure sliding door - Click here!',
    BTN_GO_TO_CONFIGURATOR_DOOR: 'Configure door - Click here!',
    BTN_GO_TO_CONFIGURATOR_ROOF_WINDOW: 'Configure skylight door - Click here!',
    PACKETS: 'PACKETS',
    SERIES: 'Series',
    PACKET_SELECTED: 'Some accessories are enabled in package. If you want to remove them, change package.',
    DIMENSION_DM: 'Dimensions are given in module (whole decimeter) with a 20 mm stand for insulation. This means that a window, such as 10x12, has a frame size of 980x1180mm.',
    DIMENSION_MM_WIDTH: 'Enter the exact frame size dimensions in millimeters without deductions. Minimium Width: {{min}} mm. Max width: {{max}} mm',
    DIMENSION_MM_HEIGHT: 'Minimium height: {{min}} mm. Max height: {{max}} mm',
    HANDLES_SIDE: 'Handles position',
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
    INISDE_GLASS: 'Invändigt glas',
    OUTISDE_GLASS: 'Utvändigt glas',
    NO_NCS_INFO: 'Not found any NCS color, try another color code.',
    PRODUCT_LOOK_INFO: 'The product image is just an example image and may be extra-equipped.',
    NCS_INFO: 'Please, input color code',
    SET_DEFAULT_COLOR: 'Set default color',
    ANGLE: 'Angle side',
    PRODUCT_NOT_AVAILABLE: 'Product not available, please choose other serie',
    CALCULATE_PRICE_LINK: 'Calculate Your shipping here',
    MULLION_TYPES: 'Mullion types',
    SMOOTH: 'Smooth',
    DECOR: 'Decor',
    BAR_TYPE: 'Type',
    FOLD_ON: 'Fold on',
    COLOR_WARNING: 'The color shown on the screen may be slightly different from reality',
    DOOR_INSIDE_OUTSIDE_COLOR_INFO: 'It is only possible to choose the same color on the inside and outside, or the standard white interior and optional color outside',
    FLASHING: 'Flashing',
    ADDITIONAL_ACCESSORIES: 'Additional accessories',
    INCLUDED_ACCESSORIES: 'Included accessories',
    WIDTH_DIMENSION_INFO: 'Available width dimensions: ',
    HEIGHT_DIMENSION_INFO: 'Available height dimensions: ',
    DIMENSIONS_CONTACT_INFO: 'Please contact us: 0431-37 14 00.',
    GO_TO_PRODUCT: 'Go to product',
    TILL: 'Till',
    U_VALUE: 'U-value',
    READ_MORE_ABOUT_THIS_SERIE: 'Read more about this serie',
    SHAPE_HEADER: 'Select shape',
    WARM: 'Warm',
    ALUMINIUM: 'Aluminium',
    GLAZING_SPACERS: 'Glazing spacers',
    GLAZING_SPACER_COLOR_CHANGE_INFO: 'When you change the color, spacer color also changes. See under the Glazing tab.',
    HANDLE_INSIDE: 'Handle inside',
    HANDLE_OUTSIDE: 'Handle outside',
    BE_CREATIVE: 'Be creative',
    STOCK_ITEM: 'Stock item',
    FAST_DELIVERY: 'Fast delivery',
    REGULAR_PRICE: 'Private client price',
    NORMAL_PRICE: 'Normal price',
    INCLUDING_TAX: 'incl. tax',
    COLOR_RULE_NOTICE: 'When the product exceeds the dimensions 4862x2600mm, we can not offer dark colors due to the risk of expansion in hot weather and sunlight.',
    DIMENSION_RULE_NOTICE: 'You have chosen a dark color that is not available in the selected size. Maximum dimensions are 4862x2600mm due to the risk of expansion in hot weather or sunlight.',
    DEFAULT_CONFIGURATIONS: 'Default configuration',
    DESIGN_YOURSELF: 'Design yourself',
    EXTERNAL_MUNTIN: 'External muntin',
    MIDDLEGLASS_MUNTIN: 'Middle glass muntin',
    IN_OUT_DUPLEX_MUNTIN: 'Both side muntin',
    DESIGN_YOURSELF_DESCRIPTION_HEADER: 'Create your own design with mullions and muntins',
    DESIGN_YOURSELF_DESCRIPTION: 'Choose mullions and muntins you want to use. Of course, you can combine both, by going into each category.',
    MUNTINS_DESCRIPTION: 'All muntins are surface-mounted detachable bars. When choosing aluminum, the bar is made entirely of aluminum and has the same color on both sides of the bar as the product\'s external color. This type of bar can not be painted in two colors. For other solutions or materials see "Design yourself". Note that diagonal bars can only be made as middle glass muntins.',
    MULLIONS_DESCRIPTION: 'Mullion is glass-dividing bar. Mullion is painted in the same color as the rest of the construction.',
    CLOSE: 'Close',
    MUNTIN_CHANGE_INFO: 'When you change the color, muntin color also changes. See under mullions & muntins tab.',
    MUNTIN_DIDNT_CHANGE_INFO: 'We couldn\'t find muntin color matching current construction color. See under mullions & muntins tab.',
    VISUALIZATION_NOTICE: 'The drawing is only an example of what it might look like.',
    READ_MORE: 'Read more',
    GLAZING_RULE_NOTICE: "Selected glass types combination is not possible. Please choose another combination or contact us for help 0431-37 14 00.",
    DIAGONAL_SETUP_RULE_NOTIFICATION: "You selected predefined setup that contains diagonal bars. Only middleglass bars are available for this configuration.",
    ORNAMENT_GLASS_RULE_NOTICE: "It is not possible to combine safety glass on the inside with ornaments on the inside. Please select one of the options.",
    GO_TO_CART: "Go to cart",
    PRODUCTS_ADDED_TO_SHOPPING_CART: "PRODUCTS ARE ADDED TO YOUR SHOPPING CART",
    ADD_TO_CART_AND_CONTINUE: "Add to cart and continue shopping",
    RECOMMEND_ADDING_ACCESSORIES: "We recommend adding the following accessories",
    EXCLUDING_TAX: 'excl. moms',
    CONTROL_SIDE: 'Control side',
    BOX: 'Box',
    FABRIC: 'Fabric',
    TOP_LATH: 'Top lath',
    LOUVRE: 'Louvre',
    BOTTOM_RAIL: 'Bottom rail',
    LATH: 'Lath',
    SHEATING: 'Sheating',
    MONTAGE_TYPE: 'Montage type',
    DRIVE: 'Drive',
    STACKING_TYPE: 'Stacking type',
    TOP_RAIL: 'Top rail',
    CHAIN: 'Chain',
    BASEMENT_WINDOW_RULE_NOTICE: "To the selected size, it is only possible to select hasps. If you want to get handles, please select bigger size.",
    MAX_DIMENSIONS_NOTICE: "Dimensions changed, because it is not possible to add color to the selected dimensions.",
    CONTACT_US_FOR_PRICE: "Contact us for price",
    CART_PAYMENT_INFO: 'Pay immediately, later or use split payment with Svea.',
    CLICK_HERE: 'click here',
    JUMP_TO_CONFIGURATOR_LABEL: 'If you want to configure your product, you can do it easily using our configurator. To do so',
};
